import EsBlockHero from './EsBlockHero';
import EsBlockFeatureCards from './EsBlockFeatureCards';
import EsBlockPoints from './EsBlockPoints';
import EsBlockHeading from './EsBlockHeading';
import EsBlockRichText from './EsBlockRichText';
import EsBlockMarker from './EsBlockMarker';

/* Each Crafter block content type and the escapade component that draws it. A type with
   no renderer here draws nothing: a block added in Studio before its renderer has merged
   is skipped, never a crash. */
export const BLOCKS = {
    '/component/hero': EsBlockHero,
    '/component/feature-cards': EsBlockFeatureCards,
    '/component/points': EsBlockPoints,
    '/component/heading': EsBlockHeading,
    '/component/rich-text': EsBlockRichText,
    '/component/marker': EsBlockMarker,
};

export const esBlockFor = ( pType ) => BLOCKS[ pType ] ?? null;
